module.exports = __webpack_public_path__ + "media/bowls/bowl-with-hearts--yellow-c04dcb02.svg";